

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumEntityTypes } from './../enums';
import { EnumDeliveryMethods } from './../enums';
export class SendDocumentParams extends BaseEntity
{   
    public EntityType: EnumEntityTypes; 
    public IsHebrew: boolean; 
    public DocumentNumber: number; 
    public Email: string; 
    public DeliveryMethod: EnumDeliveryMethods; 
	
}



